// Product Thumbnail JS

const productMainCarousel = document.querySelector(".it-product--media-gallery");
const productThumbnails = document.querySelectorAll(".it-product--media-gallery-thumbnails li");

// initialize Flickity slider
const isFlicktiyInit = setInterval(() => {
    if (window.Flickity != undefined) {
        clearInterval(window.Flickity);
        flickityInit();
    }
}, 100);
function flickityInit() {
    const productMainCarouselFlkt = new Flickity(productMainCarousel, { 
        "contain": true, 
        "pageDots": false 
    });

    // galllery thumbnail function
    productThumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener("click", () => {
            productThumbnails.forEach(el => el.classList.remove("active"));
            thumbnail.classList.add("active");
            productMainCarouselFlkt.select(index);
        });
    });

    // flickity select funciton

    productMainCarouselFlkt.on("change", (index) => {
        productThumbnails.forEach(el => el.classList.remove("active"));
        productThumbnails[index].classList.add("active");
    });
}

// Product Location JS

class ProductLocation extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        
        const all_countries = document.querySelector("#all_countries");
        const available_countries = ["United States","Canada"];
        const country_select = this.querySelector("select[name='properties[Country]'");
        const province_select = this.querySelector("select[name='properties[Province]'");
        const REMOVE_STATES = ["American Samoa", "Armed Forces Americas", "Armed Forces Europe", "Armed Forces Pacific", "Guam", "Marshall Islands", "Northern Mariana Islands", "Palau", "Puerto Rico", "Virgin Islands", "Federated States of Micronesia"];
        
        if (country_select && available_countries) {
            let find_country_option = [];
            available_countries.forEach((country) => {
                find_country_option = all_countries.querySelector(
                    "[value='" + country + "']"
                );

                if (find_country_option) {
                    let clone = find_country_option.cloneNode(true);
                    if (clone) {
                        country_select.appendChild(clone);
                        renderOption();
                        document.querySelector(".it-product--actions-button").removeAttribute("disabled");
                    }
                }
            });
        }

        if (country_select) {
            country_select.addEventListener("change", function(event) {
                if (event.target.value == "Canada") {

                    // show modal
                    window.MicroModal.show("can-blood-modal");

                    // change message
                    document.querySelector(".it-product--message.it-product--blood-draw").classList.add("hide");
                    document.querySelector(".it-product--message.it-product--mbd").classList.remove("hide");


                } else {

                    // change message
                    document.querySelector(".it-product--message.it-product--blood-draw").classList.remove("hide");
                    document.querySelector(".it-product--message.it-product--mbd").classList.add("hide");
                }

                renderOption();

                // update prouct price

            });
        }

        if (province_select) {
            province_select.addEventListener("change", function(event) {
                if (RESTRICTED_STATES.includes(event.target.value)) {
                    // show modal
                    window.MicroModal.show("us-blood-modal");

                }
            });
        }

        function renderOption() {
            const selected_option = country_select.options[country_select.selectedIndex];

            let get_selected_provinces = selected_option.getAttribute("data-provinces");
            get_selected_provinces = JSON.parse(get_selected_provinces);
            get_selected_provinces = get_selected_provinces.filter((province) => !REMOVE_STATES.includes(province[0]));

            clearOptions(province_select);
            setOptions(province_select, get_selected_provinces);
        }

        function clearOptions(selector) {
            while (selector.firstChild) {
                selector.removeChild(selector.firstChild);
            }
        }

        function setOptions(selector, values) {
            for (let i = 0, count = values.length; i < values.length; i++) {
            const opt = document.createElement("option");
                opt.value = values[i][0];
                opt.innerHTML = values[i][1];
                selector.appendChild(opt);
            }
        }
    }
}

customElements.define('product-location', ProductLocation);


// product add functionality

// Product Data

const bundleProductData = window.bundleProducts;
const isLoginRequired = window.isLoginRequired;
const isCustomer = window.isLoggedIn;

// Cart Item

let cartItems = [];
let quantity = 1;
let province = "Alabama";
let country = "United States";
let selectedBloodDrawMethod = "Blood draw in lab";


// Check if the Categories already in the cart
const existItems = [];

fetch('/cart.js')
.then( res => res.json() )
.then( data => {
  if (data.items.length > 0 ) {
    data.items.forEach( function(item) {
      if(item.properties.hasOwnProperty("_bundle_type")) {
        existItems.push(item.product_title);
      }
    });

    disableExistItems(existItems);
  }
});

function disableExistItems(items) {

  items.forEach(function(item) {
    document.querySelector(`div[data-title="${item}"]`).classList.add("disabled");
  });
}

// Check Item based on search params
const catSearchParams = new URLSearchParams(window.location.search);
const hasSearchParams = catSearchParams.getAll("cat[]");

if(hasSearchParams.length > 0) {
  hasSearchParams.forEach(function(current) {
    document.querySelector(`div[data-sku="${current}"]`).classList.add("checked");
  });
}

// Select Bundle Product Functionality

document.querySelectorAll(".bundle-product-box").forEach(function(box) {
  box.addEventListener("click", function() {
    box.classList.toggle("checked");
  });
});

// Show Login Popup for Non Logged in Customer


function showLoginPup() {
  MicroModal.show("customer-login-modal");
  document.querySelector("#it-product--add-to-cart").classList.remove("loader");
  document.getElementById("customer-log-in").addEventListener("click", function(event) {
    event.target.disabled = true;
    event.target.innerText = "Redirecting...";
    createBundle(document.getElementById("customer-log-in").dataset.url);
  });
}

// Create Bundle

function createBundle(url="/cart") {
  const bundleCart = {
    'items': cartItems
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(bundleCart)
  })
  .then(function() {
    window.location.href=url;
  })
  .catch(function(error) {
    console.error('Error:', error);
  });
}

// Generate Bundles

function generateBundles() {
  // get selected Bundle items'
  const selectedBundleItems = [...document.querySelectorAll(".bundle-product-box.checked")];
  const country = document.getElementById("it-product--country").value;
  const province = document.getElementById("it-product--state").value;
  if ( selectedBundleItems.length > 0 ) {
    selectedBundleItems.forEach(function(bundleItem) {
      bundleProductData.forEach(function(product) {
        if ( product.title === bundleItem.dataset.title ) {
          const currentVariantId = product.variants[0].id;
          cartItems.push({
            'id': currentVariantId,
            'quantity': 1,
            'properties': {
              'Country': country,
              'Province': province,
              '_bundle_type': "Blood draw in lab"
            }
          });
        }
      });
    });

    if (isCustomer) {
      createBundle();
    } else {
      if (isLoginRequired) {
        showLoginPup();
      }
      else {
        createBundle();
      }
    }

  } else {
    document.getElementById("bundle-error-message").innerText = "Please select a Bundle Product";
    document.querySelector("#it-product--add-to-cart").classList.remove("loader");
  }

}

// Add to Cart Functionality

document.querySelector("#it-product--add-to-cart").addEventListener("click", function() {
  document.querySelector("#it-product--add-to-cart").classList.add("loader");
  generateBundles();
});